import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Callback from '@/components/Callback'
import ValueEditor from '@/components/ValueEditor'
import History from '@/components/History'
import AuditLogs from '@/components/AuditLogs'
import UnrulyPax from '@/components/UnrulyPax'
import { routesNames } from '@/core/constants'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: routesNames.home,
      component: Home,
      children: [
        {
          path: '/value-editor',
          name: routesNames.valueEditor,
          component: ValueEditor
        },
        {
          path: '/history',
          name: routesNames.history,
          component: History
        },
        {
          path: '/audit-logs',
          name: routesNames.auditLogs,
          component: AuditLogs
        },
        {
          path: '/unruly-pax',
          name: routesNames.unrulyPax,
          component: UnrulyPax
        }
      ]
    },
    {
      path: '/login',
      name: routesNames.login,
      component: Login
    },
    {
      path: '/callback',
      name: routesNames.callback,
      component: Callback
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js